(() => {
  const nativeSorts = new Set(window.DDNativeSortValues || ['manual','most-relevant','best-selling','title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending']);
  const selected = search => {
    const params = new URLSearchParams(search);
    return params.get('dd_sort') === 'trending' && !nativeSorts.has(params.get('sort_by'));
  };
  const sortUrl = (href, sort) => {
    const url = new URL(href);
    for (const key of ['page','dd_cursor','dd_sort','sort_by']) url.searchParams.delete(key);
    if (sort === 'trending') url.searchParams.set('dd_sort','trending');
    else if (nativeSorts.has(sort)) url.searchParams.set('sort_by',sort);
    return url;
  };
  window.DDTrending = { selected, sortUrl };
  function boot() {
    const root = document.querySelector('dd-collection,dd-supplies-collection');
    if (!root || root.dataset.trendingEnabled !== 'true') return;
    const select = root.querySelector('[data-dd-sort]');
    if (!select) return;
    const active = selected(location.search);
    const visibleSorts = new Set(Array.from(select.options, option => option.value));
    if (!active && !visibleSorts.has(select.dataset.nativeSort)) {
      location.replace(sortUrl(location.href,'manual').toString());
      return;
    }
    const nativeDefault = Array.from(select.options).find(option=>option.defaultSelected)?.value || select.value;
    const syncSort = () => { const params=new URLSearchParams(location.search); select.value=selected(location.search)?'trending':(nativeSorts.has(params.get('sort_by'))?params.get('sort_by'):nativeDefault); select.dispatchEvent(new Event('dd:selection-sync')); };
    window.addEventListener('pageshow',()=>requestAnimationFrame(syncSort));
    const option = document.createElement('option'); option.value = 'trending'; option.textContent = root.dataset.trendingLabel; select.add(option,select.options[1] || null);
    if (active) select.value = 'trending';
    select.dispatchEvent(new Event('dd:selection-sync'));
    const form = root.querySelector('form');
    const grid = root.querySelector('[data-dd-results]');
    const more = root.querySelector('[data-dd-load-more]');
    const dialog = root.querySelector('dialog');
    const state = { busy:false, cursor:null, snapshot:null, loaded:0, sequence:0, abort:null };
    const status = document.createElement('div'); status.className = 'dd-trending-status'; status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    const skeleton = document.createElement('div'); skeleton.className = 'dd-trending-skeleton'; skeleton.setAttribute('aria-hidden','true');
    for (let index=0;index<4;index++) {
      const card=document.createElement('div');card.className='dd-trending-skeleton__card';
      for (const part of ['image','title','price']) { const placeholder=document.createElement('div');placeholder.className=`dd-trending-skeleton__${part}`;card.append(placeholder); }
      skeleton.append(card);
    }
    if (active) { grid.before(status); grid.before(skeleton); if(more) more.hidden = true; }
    const format = () => new URLSearchParams(location.search).get('dd_format') || root.dataset.defaultFormat || 'all';
    const category = () => root.querySelector('[data-dd-category]')?.value || new URLSearchParams(location.search).get('dd_category') || 'all';
    const filteredUrl = sort => {
      const url = new URL(form.action, location.href);
      for (const [key,value] of new URLSearchParams(location.search)) {
        if (!key.startsWith('filter.') && !['page','dd_cursor','sort_by','dd_sort','dd_format','dd_category'].includes(key)) url.searchParams.append(key,value);
      }
      for (const [key,value] of new FormData(form)) {
        if (String(value).trim() && !['sort_by','dd_sort','page','dd_cursor'].includes(key)) url.searchParams.append(key,value);
      }
      if (root.dataset.defaultFormat) { url.searchParams.set('dd_format',format()); url.searchParams.set('dd_category',category()); }
      return sortUrl(url.toString(),sort);
    };
    document.addEventListener('change', event => {
      if (!root.contains(event.target)) return;
      if (event.target === select && (active || select.value === 'trending')) {
        event.preventDefault(); event.stopImmediatePropagation(); location.assign(filteredUrl(select.value));
      } else if (active && event.target.matches('[data-dd-category]')) {
        event.preventDefault(); event.stopImmediatePropagation(); location.assign(filteredUrl('trending'));
      } else if (active && event.target.matches('[data-dd-supply-navigation]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        const url = new URL(event.target.value,location.href);
        for (const [key,value] of new URLSearchParams(location.search)) {
          if (key.startsWith('filter.') || ['preview_theme_id','pb'].includes(key)) url.searchParams.append(key,value);
        }
        location.assign(sortUrl(url.toString(),'trending'));
      }
    },true);
    if (!active) return;
    const categorySelect = root.querySelector('[data-dd-category]');
    if (categorySelect) {
      categorySelect.value = new URLSearchParams(location.search).get('dd_category') || 'all';
      categorySelect.dispatchEvent(new Event('dd:selection-sync'));
    }
    const formatInput = root.querySelector('[data-dd-format-input]'); if(formatInput) formatInput.value = format();
    document.documentElement.dataset.ddFormat = format();
    root.querySelectorAll('[data-dd-format-link]').forEach(link => {
      if(link.dataset.ddFormatLink === format()) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
    });
    document.addEventListener('submit', event => {
      if (event.target !== form) return;
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(filteredUrl('trending'));
    },true);
    document.addEventListener('click', event => {
      const target = event.target.closest('button,a'); if(!target || !root.contains(target)) return;
      if (target.matches('[data-dd-open-filter]')) { event.preventDefault(); event.stopImmediatePropagation(); dialog.showModal(); }
      else if (target.matches('[data-dd-close-filter]')) { event.preventDefault(); event.stopImmediatePropagation(); dialog.close(); root.querySelector('[data-dd-open-filter]').focus(); }
      else if (target.matches('[data-dd-load-more]')) { event.preventDefault(); event.stopImmediatePropagation(); if(!state.busy && state.cursor) load(true); }
      else if (target.matches('[data-dd-format-link]')) {
        event.preventDefault(); event.stopImmediatePropagation(); const url=sortUrl(target.href,'trending');
        for(const [key,value] of new URLSearchParams(location.search)){if(!['page','dd_cursor','sort_by','dd_sort','dd_format','dd_category'].includes(key))url.searchParams.set(key,value);}
        url.searchParams.set('dd_format',target.dataset.ddFormatLink); url.searchParams.set('dd_category',category()); location.assign(url);
      } else if (target.matches('a') && (target.closest('dialog') || target.matches('.dd-active-filter,[data-dd-reset]'))) {
        const url = new URL(target.href,location.href);
        if (url.origin === location.origin && url.pathname.includes('/collections/')) {
          event.preventDefault(); event.stopImmediatePropagation();
          if(root.dataset.defaultFormat) url.searchParams.set('dd_format',format());
          location.assign(sortUrl(url.toString(),'trending'));
        }
      }
    },true);
    dialog?.addEventListener('click',event=>{ if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} });
    dialog?.addEventListener('close',()=>root.querySelector('[data-dd-open-filter]')?.focus());
    function payload() {
      const filters={};
      for(const [key,value] of new URLSearchParams(location.search)) {
        if (!key.startsWith('filter.')) continue;
        if(Object.hasOwn(filters,key)) throw new Error('unsupported_filter');
        filters[key]=value;
      }
      return { collection:root.dataset.trendingCollection, handle:root.dataset.trendingHandle, path:location.pathname, section:root.dataset.sectionId,
        country:root.dataset.trendingCountry,currency:root.dataset.trendingCurrency,locale:root.dataset.trendingLocale, format:format(),category:category(),filters };
    }
    async function load(append, refresh=false) {
      if(state.busy) return;
      state.busy=true; const sequence=++state.sequence;
      state.abort?.abort(); state.abort=new AbortController();
      const timer=setTimeout(()=>state.abort.abort(),30000);
      status.classList.add('is-loading');
      status.textContent=append?root.dataset.trendingLoadingMore:root.dataset.trendingLoading;
      if (state.loaded>0) grid.after(skeleton); else grid.before(skeleton);
      skeleton.hidden=false;
      grid.setAttribute('aria-busy','true'); if(more) more.setAttribute('aria-disabled','true');
      try {
        const url=new URL('/apps/trending-sort',location.origin); url.searchParams.set('payload',JSON.stringify(payload()));
        if(append && state.cursor) url.searchParams.set('cursor',state.cursor);
        if(refresh) url.searchParams.set('refresh','1');
        const response=await fetch(url,{headers:{Accept:'application/json'},credentials:'same-origin',signal:state.abort.signal});
        const data=await response.json();
        if(!response.ok) throw new Error(data.error || 'unavailable');
        if(sequence!==state.sequence) return;
        if(typeof data.snapshot!=='string'||!Number.isSafeInteger(data.total)||data.total<0||!Number.isSafeInteger(data.count)||data.count<0||data.count>12||typeof data.html!=='string'||!(data.next_cursor===null||typeof data.next_cursor==='string')||(append&&state.snapshot!==data.snapshot)) throw new Error('invalid_response');
        const parsed=new DOMParser().parseFromString(data.html,'text/html');
        const fragment=parsed.querySelector('[data-trending-fragment="1"]'); if(!fragment) throw new Error('invalid_response');
        const cards=Array.from(fragment.querySelectorAll('[data-dd-card]'));
        if(cards.length!==data.count) throw new Error('invalid_response');
        const seen=new Set(append?Array.from(grid.querySelectorAll('[data-dd-card]')).map(card=>card.dataset.productId):[]);
        for(const card of cards){if(!/^[1-9][0-9]*$/.test(card.dataset.productId)||seen.has(card.dataset.productId))throw new Error('catalog_changed');seen.add(card.dataset.productId);}
        if(!append){grid.replaceChildren();state.loaded=0;}
        grid.append(...cards); grid.dataset.trendingReady='true'; skeleton.hidden=true;
        state.snapshot=data.snapshot;state.cursor=data.next_cursor;state.loaded+=data.count;
        status.textContent=root.dataset.trendingResults.replace('__SHOWN__',String(state.loaded)).replace('__TOTAL__',String(data.total));
        const empty=root.querySelector('[data-dd-empty]'); if(empty)empty.hidden=data.total!==0;
        if(more)more.hidden=!state.cursor;
      } catch(error) {
        if(sequence!==state.sequence)return;
        skeleton.hidden=true;
        if(['catalog_changed','collection_changed','pagination_expired','installation_changed','ranking_not_available'].includes(error.message)){grid.replaceChildren();grid.removeAttribute('data-trending-ready');state.loaded=0;state.cursor=null;state.snapshot=null;}
        status.replaceChildren(document.createTextNode(root.dataset.trendingError));
        const retry=document.createElement('button');retry.type='button';retry.className='dd-trending-retry';retry.textContent=root.dataset.trendingRetry;retry.addEventListener('click',()=>load(false,true));status.append(retry);
        const fallback=document.createElement('a');fallback.textContent=root.dataset.trendingFallback;fallback.href=sortUrl(location.href,'manual');status.append(fallback);
        if(more)more.hidden=true;
      } finally {
        clearTimeout(timer); if(sequence===state.sequence)status.classList.remove('is-loading'); if(sequence===state.sequence){state.busy=false;grid.removeAttribute('aria-busy');more?.removeAttribute('aria-disabled');}
      }
    }
    window.addEventListener('pagehide',()=>state.abort?.abort());
    window.addEventListener('pageshow',event=>{if(event.persisted){requestAnimationFrame(()=>{
      const params=new URLSearchParams(location.search);
      if(categorySelect){categorySelect.value=params.get('dd_category')||'all';categorySelect.dispatchEvent(new Event('dd:selection-sync'));}
      root.querySelectorAll('[data-dd-supply-navigation]').forEach(select=>{select.value=Array.from(select.options).find(option=>option.defaultSelected)?.value||select.options[0].value;select.dispatchEvent(new Event('dd:selection-sync'));});
      form.querySelectorAll('input[name^="filter."]').forEach(input=>{if(input.type==='number')input.value=params.get(input.name)||'';});
      state.busy=false;load(false);
    });}});
    load(false);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
